import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ThemeSettings {
    primaryLogo: string | null;
    secondaryLogo: string | null;
    favicon: string | null;

    primaryColor: string;
    secondaryColor: string;
    textPrimaryColor: string;
    textSecondaryColor: string;
    backgroundPrimaryColor: string;
}

export type ThemeColors = Pick<
    ThemeSettings,
    "primaryColor" | "secondaryColor" | "textPrimaryColor" | "textSecondaryColor" | "backgroundPrimaryColor"
>;

const initialState: ThemeSettings = {
    primaryLogo: null,
    secondaryLogo: null,
    favicon: null,

    primaryColor: "#3B82F6",
    secondaryColor: "#8B5CF6",
    textPrimaryColor: "#1F2937",
    textSecondaryColor: "#6B7280",
    backgroundPrimaryColor: "#FFFFFF",
};

const themeSettings = createSlice({
    name: "themeSettings",
    initialState,
    reducers: {
        updateSettings: (state, action: PayloadAction<Partial<ThemeSettings>>) => {
            Object.assign(state, action.payload);
        },

        resetToDefaults: () => initialState,
    },
});

export const { updateSettings, resetToDefaults } = themeSettings.actions;

export default themeSettings.reducer;
